<template>
    <div>
        <div v-if="isEdit" class="uploadt" style="display: flex;display: -webkit-flex;">
            <!--表格上传-->
            <Upload
                    ref="upload"
                    action="/common/upload"
                    :headers="header"
                    :show-upload-list="false"
                    :on-format-error="handleFormatError"
                    :on-success="handleUpload"
                    :on-error="uploadFail"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    :on-progress="handleProress"
                    style="margin-right: 10px;"
            >
                <Button icon="md-cloud-upload">上传附件</Button>
            </Upload>
            <ul class="upload-file-list">
                <li v-for="(item, index) in files" :key="index">
                    <Tag :name="item.fileName" closable  @on-close="handleTagClose">
                        <span @click="previewFile(index,item.diskFileName)" class="txt-span">{{item.fileName}}</span>
                        <a  class="txt-a" :href="'/static/file/'+item.diskFileName" :download="item.fileName" target="_blank">下载</a>
                    </Tag>
                </li>
                <li v-for="item in progressFiles" :key="item.uid">
                    <div v-if="item.status !=='finished'">
                        <span>{{item.name}}</span>
                        <Progress :percent="Math.round(item.percentage)"></Progress>
                    </div>
                </li>
            </ul>
        </div>
        <ul v-else>
            <li class="up-file-item" v-for="(item,index) in files" :key="index">
                <div v-if="(/\.pdf$/ig).test(item.diskFileName)" @click="handleOpenWin(item.diskFileName)" class="article-file" >
                    <span>附件{{index+1}}：</span>
                    {{item.fileName}}
                </div>
                <div v-else-if="(/\.(jpg|jepg|gif|bmp|png)$/ig).test(item.diskFileName)" @click="previewFile(index,item.diskFileName)" class="article-file" >
                    <span>附件{{index+1}}：</span>
                    {{item.fileName}}
                </div>
                <a v-else class="article-file" :href="'/static/file/'+item.diskFileName" :download="item.fileName" target="_blank">
                    <span>附件{{index+1}}：</span>
                    {{item.fileName}}
                </a>
            </li>
        </ul>
        <img-viewer :uploadList="files" :picModal.sync="picModal" :imgIndex="imgIndex"></img-viewer>
    </div>


</template>
<style scoped>
    /*单行上传*/
    .upload-file-list{
        line-height: 28px;
    }
    .upload-file-list .txt-a{
        margin-left: 5px;
    }

    .up-file-item{
        font-size: 14px;
        color: #2d8cf0;
        text-decoration: underline;
        cursor: pointer;

    }
</style>
<script>
    export default {
        data(){
            return{
                imgIndex:'',
                picModal:false,
                files:[],
                progressFiles:[],
                header:{
                    Authorization: 'Bearer '+ localStorage.getItem('access_token')
                },
            };
        },
        props: {
            /*上传文件列表*/
            uploadList:{
                type: Array,
            },
            isEdit:{
                type:Boolean,
                default:true
            }
        },
        mounted(){
            (this.uploadList) && (this.files=this.uploadList);
        },
        watch:{
            uploadList:function () {
                (this.uploadList) && (this.files=this.uploadList);
            }
        },
        methods:{
            handleProress(event, file, fileList){
                this.progressFiles=fileList;
            },
            /*预览*/
            previewFile(imgIndex,src){
                if( (/\.pdf$/ig).test(src)){
                    this.handleOpenWin(src);
                }else if( (/\.(jpg|jepg|gif|bmp|png)$/ig).test(src) ){
                    this.imgIndex=imgIndex;
                    this.picModal=true;
                }
            },
            handleOpenWin(src){
                let newpage = this.$router.resolve({
                    name: 'pdfView',
                    query:{
                        src:src,
                    },
                });
                window.open(newpage.href, '_blank');
            },
            //上传模块
            /*标签删除*/
            handleTagClose(event, name){
                for(let i=0;i<this.files.length;i++){
                    if(this.files[i].fileName===name){
                        this.files.splice(i,1);
                        /*发送更新值 以便父组件.sync接收*/
                        this.$emit('update:uploadList',this.files);
                    }
                }
            },
            /*上传成功*/
            handleUpload(response, file, fileList){
                // {
                //     name:"Java并发编程的艺术.zip"
                //     percentage:100
                //     response:Array[1]
                //     showProgress:false
                //     size:10271346
                //     status:"finished"
                //     uid:1558603421902
                //
                // }
                if(file.response){
                    file.fileName=file.response.fileName;
                    file.diskFileName=file.response.diskFileName;
                    delete file.response;
                    this.files.push(file);
                    this.$Message.success('上传成功');
                    this.$emit('update:uploadList',this.files);
                }else {
                    this.$Message.error('上传失败！');
                }
            },
            /*上传失败*/
            uploadFail(){
                this.$Message.error('上传失败,网络异常！');
            },
            /*文件过大*/
            handleMaxSize(file){
                // this.$Notice.warning({
                //     title: '文件过大',
                //     desc: file.name + ' 文件太大,不能超过50M.'
                // });
            },
            /*格式验证失败*/
            handleFormatError (file) {
                this.$Message.error('文件格式不支持！请上传图片或者压缩包');
                // this.$Notice.warning({
                //     title: 'The file format is incorrect',
                //     desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
                // });
            },
            /*最多上传*/
            handleBeforeUpload(){
                // const check = this.files.length < 5;
                // if (!check) {
                //     this.$Notice.warning({
                //         title: '最多可上传5个'
                //     });
                // }
                // return check;
            },
        },
    };
</script>
